import script from "./TopNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./TopNavigation.vue?vue&type=script&setup=true&lang=js"

import "./TopNavigation.vue?vue&type=style&index=0&id=0dc264d8&scoped=true&lang=css"

import exportComponent from "/var/www/prescribe_platform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0dc264d8"]])

export default __exports__